import { reauthenticateWithCredential, EmailAuthProvider } from "firebase/auth";
import { initFirebase } from "@core/services/api/firebase";
import { apiRequest } from "@core/services/api/apiRequest";

export type UpdateUserEmailArgs = {
  currentEmail: string;
  newEmail: string;
  password: string;
};

export type UpdateUserEmailResponse = {
  user_data: Record<string, unknown>;
  authToken: string;
};

/**
 * Updates user email via Firebase re-authentication and backend API
 */
export async function updateUserEmail({
  currentEmail,
  newEmail,
  password,
}: UpdateUserEmailArgs): Promise<UpdateUserEmailResponse> {
  const auth = await initFirebase();

  // Get the current user
  const user = auth.currentUser;

  if (!user) {
    throw new Error("No user is currently signed in.");
  }

  // Create a credential with the user's email and password
  const credential = EmailAuthProvider.credential(currentEmail, password);

  // Re-authenticate the user
  await reauthenticateWithCredential(user, credential);

  // Use the backend API to update the email (avoids email verification requirement)
  const response = (await apiRequest(`/profile/email/`, "POST", {
    email: newEmail,
    password: password,
  })) as { user_data: Record<string, unknown> };

  // Reload the user and refresh the token
  await user.reload();
  const authToken = await user.getIdToken(true);

  return {
    user_data: response.user_data,
    authToken,
  };
}

export default updateUserEmail;
